<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal size="xl" :visible="modal.show" :data="model"
                   :title="model.uuid ? $t(`Update User`) : $t(`Create New User`)" @show="onShow" @hidden="onHidden"
                   @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation" :ok-title="$t('Submit')"
                   :is-loading="loading" scrollable>
      <div class="row pb-3">
        <div class="col-xl-7 col-md-12 border-right pr-3">
          <div class="row">
            <div class="col-md-6">
              <input-widget :model="model" attribute="first_name"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="last_name"/>
            </div>
            <div class="col-md-12">
              <branch-select-input-widget :model="model" attribute="branch_uuid" :rules="requiredBranch"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="email" type="email"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="password" type="password"/>
            </div>
            <div class="col-md-12">
              <hr>
            </div>
            <div class="col-md-6">
              <country-select-input-widget attribute="country_code" :model="model"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="address_1"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="address_2"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="state"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="county"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="city"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="zip_code"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="phone"/>
            </div>
            <div class="col-md-12">
              <hr>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="title"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="department"/>
            </div>
            <div class="col-md-6">
              <input-widget :model="model" attribute="role_id" type="select2" value-field="id"
                            display-field="${item.name}" :items="permissionRoles"
                            @select2Select="onRoleSelect" @select2Unselect="onRoleUnselect"/>
            </div>
            <div class="col-md-6 pt-md-4" v-if="model.uuid">
              <input-widget :model="model" attribute="is_blocked" type="checkbox" is-switch size="lg"/>
            </div>

          </div>
        </div>
        <div class="col-xl-5 col-md-12 pl-3">
          <h5>{{ $t('Permissions') }}</h5>
          <div v-for="group in permissionGroups" class="pb-2 pt-2 border-bottom">
            <b-form-checkbox v-model="group.checked" @change="onGroupCheckboxChange(group)">
              <b>{{ group.name | toUpperCaseFirst | removeUnderscores }}</b>
            </b-form-checkbox>
            <div class="row pl-4" v-if="group.permissions.length > 1">
              <div class="col-sm-12 col-md-12 col-xl-6" v-for="permission in group.permissions"
                   v-if="!permission.name.includes('add_')">
                <b-form-checkbox v-model="permission.checked" @change="onPermissionCheckboxChange(group, permission)">
                  {{ permission.display_name | toUpperCaseFirst | removeUnderscores }}
                </b-form-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import InputWidget from "../../../core/components/input-widget/InputWidget";
  import UserModel from "./User.model";
  import {createNamespacedHelpers} from "vuex";
  import ArtisioModal from "../../../core/components/artisio-modal/ArtisioModal";
  import BranchSelectInputWidget from "../../../core/widgets/BranchSelectInputWidget";
  import _ from 'lodash';
  import CountrySelectInputWidget from "@/core/widgets/CountrySelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('setup/user');
  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');

  export default {
    name: "UserModal",
    components: {
      CountrySelectInputWidget,
      BranchSelectInputWidget,
      InputWidget, ArtisioModal
    },
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new UserModel(),
        permissionGroups: [],
        permissionRoles: [],
      }
    },
    computed: {
      ...mapState({
        modal: state => state.modal,
        editObject: state => state.modal.object,
        tableData: state => state.tableData
      }),
      ...mapStateGlobal({
        globalPermissionGroups: state => state.permissionGroups,
        globalPermissionRoles: state => state.permissionRoles
      }),
      requiredBranch: {
        get() {
          return this.model.branch_uuids.length === 0 ? 'required' : '';
        },
        set(value) {
          return value;
        }
      }
    },
    watch: {
      'model.branch_uuids'() {
        this.requiredBranch = this.model.branch_uuids.length === 0 ? 'required' : '';
      },
      editObject() {
        if (this.editObject && this.editObject.uuid) {
          this.model = new UserModel(this.editObject);
        }
      }
    },
    methods: {
      ...mapActions(['hideModal', 'createUser', 'updateUser', 'getTableData']),
      onShow() {
        this.showConfirmation = true;

        this.permissionGroups = _.cloneDeep(this.globalPermissionGroups);
        this.permissionGroups.forEach(group => {
          group.permissions.forEach(perm => {
            perm.checked = this.model.permissions.includes(perm.name);
            let split_name = perm.name.split('_')
            perm.display_name = split_name.slice(0, split_name.length - 1).join(" ")
          });
          group.checked = group.permissions.filter(perm => perm.checked).length === group.permissions.length;
        });

        this.permissionRoles = _.cloneDeep(this.globalPermissionRoles)
        this.permissionRoles.forEach(role => {
          let mappedPermissions = {}
          role.permissions.forEach(perm => {
            mappedPermissions[perm.id] = perm
          })
          role.permissions = mappedPermissions
        })
      },
      onHidden() {
        this.model = new UserModel();
        this.hideModal();
      },
      async onSubmit() {
        await this.$refs.observer.reset()
        this.model.resetErrors()
        let validateSuccess = await this.$refs.observer.validate()
        if (!validateSuccess) {
          return
        }

        let response;
        this.loading = true;

        if (this.model.password === null || this.model.password === undefined) {
          delete this.model.password;
        }

        let requestData = _.cloneDeep(this.model);
        requestData.permission_ids = [];

        this.permissionGroups.forEach(group => {
          requestData.permission_ids.push(
            ...group.permissions.filter(perm => perm.checked).map(perm => perm.id)
          );
        });

        if (!this.model.uuid) {
          response = await this.createUser(requestData);
        } else {
          response = await this.updateUser(requestData);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.getTableData(this.tableData);
          this.hideModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('User was successfully created'));
          } else {
            this.$toast('success', this.$t('User was successfully updated'));
          }
        } else {
          if (response.body.non_field_errors) {
            this.$errorDialog(response.body.non_field_errors[0])
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
      onGroupCheckboxChange(group) {
        this.$nextTick(() => {
          group.permissions.forEach(permission => {
            if (!permission.name.includes('view_assigned')) {
              permission.checked = group.checked;
            }
          });
          this.permissionGroups = [...this.permissionGroups]
        });
      },
      onPermissionCheckboxChange(group, permission) {
        this.$nextTick(() => {
          this.checkPermissionGroupDependencies(group, permission);
          group.checked = this.groupPermsAreChecked(group);
          this.permissionGroups = [...this.permissionGroups]
        });
      },
      checkPermissionGroupDependencies(group, currentClickedPermission) {
        updatePermissionGroupDependencies(group, currentClickedPermission)
      },
      onRoleSelect(role) {
        let rolePerms = role.permissions;
        let permIds = Object.keys(rolePerms);
        this.permissionGroups.forEach(group => {
          group.permissions.forEach(perm => {
            perm.checked = permIds.includes(String(perm.id));
          })
          let filtered = group.permissions.filter(perm => perm.checked);
          filtered.forEach(checkedPerm => {
            updatePermissionGroupDependencies(group, checkedPerm)
          })
          group.checked = filtered.length === group.permissions.length;
        })

      },
      onRoleUnselect() {
        this.permissionGroups.forEach(group => {
          group.permissions.forEach(perm => {
            perm.checked = false;
          })
          group.checked = false;
        })
      },
      groupPermsAreChecked(group) {
        for (let perm of group.permissions) {
          if (!perm.checked && !perm.name.includes('view_assigned')) {
            return false;
          }
        }
        return true;
      }
    },
  }

  // Remove all main permissions if view permission was unchecked
  function viewPermUnchecked(group) {
    group.permissions.forEach(perm => {
      if (!perm.name.includes('view_assigned')) {
        perm.checked = false;
      }
    })
  }

  // Remove view_assigned permission if view was checked
  function viewPermChecked(group) {
    let viewAssignedPermission = group.permissions.find(permission => permission.name.includes('view_assigned'));
    if (viewAssignedPermission) viewAssignedPermission.checked = false;
  }

  function updatePermissionGroupDependencies(group, currentClickedPermission) {
    let viewPermission = group.permissions.find(permission => (permission.name.includes('view_')
      && !permission.name.includes('view_assigned')));

    // if (currentClickedPermission.name.includes('view_') && !currentClickedPermission.name.includes('view_assigned')) {
    //   if (currentClickedPermission.checked) {
    //     viewPermChecked(group);
    //   } else {
    //     viewPermUnchecked(group);
    //   }
    // }

    // // Remove view perm if view_assigned perm is checked
    // if (currentClickedPermission.name.includes('view_assigned') && currentClickedPermission.checked) {
    //   viewPermission.checked = false;
    //   viewPermUnchecked(group);
    // }

    // Mark view permission as true if change or export permission is checked as true
    if (currentClickedPermission.checked &&
      (currentClickedPermission.name.includes('change_') || currentClickedPermission.name.includes('export_'))) {
      viewPermission.checked = true;
      // viewPermChecked(group);
    }

    // Mark view and change permission as true if delete permission is checked as true
    if (currentClickedPermission.name.includes('delete_') && currentClickedPermission.checked) {
      let changePermission = group.permissions.find(permission => permission.name.includes('change_'));
      viewPermission.checked = true;
      changePermission.checked = true;
      // viewPermChecked(group);
    }
  }
</script>

<style scoped>

</style>
